<!-- MAP VIEW -->
<div #mapContainer id="map" [class.overlay-active]="showOverlay" [class.map-loader]="showMapLoader" [ngStyle]="assetPath"></div>

<!-- Emloyee List  -->
<div *ngIf="enableEmployeesDetails" class="employee-list-card" [@slideIn] style="z-index:1">
  <app-employee-list [stopDetail]="selectedShuttleStop" [tripDetails]="tripDetails" (closePopup)="onClosePopup($event)">
  </app-employee-list>
</div>
<figure
  [ngStyle]="{ 'background-color': speedColor }"
  class="highcharts-figure location-status-card d-flex flex-dir-col just-space"
  [ngClass]="{ overspeed: mapControlService.startTripBool ?  isOverspeeding : '' }"
>
  <div id="speedometerContainer"></div>
</figure>
<!-- <div class="child-2 d-flex flex-dir-col">
  <span class="h-12" style="margin-bottom: 8px;color:#6A737D;margin-top: 5px;">Vehicle tracking
      from</span>
  <div class="d-flex align-center gap-7" *ngIf="disabledFixedDeviceToggle">
      <div class="d-flex gap-8">
          <div (click)="!driverFixedDevice?'':selectedValue('Driver App')"
              [ngClass]="{'driverFixed-selected':driverFixedDevice===false}"
              class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">
              <span class="h7">Driver App</span>
          </div>
      </div>
      <div class="d-flex gap-8">
          <div (click)="driverFixedDevice?'':selectedValue('Fixed Device')"
              [ngClass]="{'driverFixed-selected':driverFixedDevice===true}"
              class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">
              <span class="h7">Fixed Device</span>
          </div>
      </div>

  </div>

</div> -->